var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderControls", {
        attrs: { myWeek: false },
        on: {
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "deliverable-main container-fluid" },
        [
          _c("SocialList", {
            attrs: {
              filterQuery: _vm.filterQuery,
              myWeek: false,
              expandAll: _vm.expandAll
            },
            on: { collapseToggleUpdated: _vm.collapseToggleUpdate }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }